import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import jobView from '../views/JobView.vue'
import LoginView from '../views/LoginView.vue'
import UserView from '../views/UserView.vue'

Vue.use(VueRouter)
// ฟังก์ชันเช็คว่า login หรือยัง
const isAuthenticated = () => {
  const token = (localStorage.getItem("device_id") || "").trim();
  const officerId = (localStorage.getItem("officer_id") || "").trim();
  return !!token && !!officerId;
};



const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true }, 
    component: HomeView
  },
  {
    path: '/user',
    name: 'user',
    meta: { requiresAuth: true }, 
    component: UserView
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

// Navigation Guard เช็คการล็อกอิน
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next("/login"); // ถ้ายังไม่ได้ล็อกอินให้ไปหน้า login
  } else {
    next();
  }
});


export default router
